module.exports = __webpack_public_path__ + "img/meme_01.9bf97a13.jpg";